// extracted by mini-css-extract-plugin
export default {"navLink":"NavLink_navLink__68gRr","active":"NavLink_active__VY+tc"};